"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const shallow_1 = require("zustand/shallow");
const UserContext_1 = require("context/UserContext");
const helper_1 = require("hooks/useAdjustWeightModal/helper");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const HelperUtils_1 = require("utils/HelperUtils");
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const useCategories_1 = require("src/hooks/api/useCategories");
const useObjectives_1 = require("src/hooks/api/useObjectives");
const Banner_1 = __importDefault(require("./Banner"));
const Header_1 = __importDefault(require("./Header"));
const AdjustWeightDetail_1 = __importDefault(require("./adjust-weight-detail/AdjustWeightDetail"));
const AdjustObjectiveList = ({ customParams }) => {
    const { user, config: { permissions: { objectiveWeightManage } } } = (0, UserContext_1.useUser)();
    const { isCreate, editedObjectivesData, totalObjectives, fromBadgeWeight, isComplexity, isIndividual, isPercentage, setTotalWeights, setTotalObjectives, setObjectivesData, setEditedObjectivesData, setObjectiveCategories } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        isCreate: state.isCreate,
        editedObjectivesData: state.editedObjectivesData,
        totalObjectives: state.totalObjectives,
        fromBadgeWeight: state.fromBadgeWeight,
        isComplexity: state.isComplexity,
        isIndividual: state.isIndividual,
        isPercentage: state.isPercentage,
        setTotalWeights: state.setTotalWeights,
        setTotalObjectives: state.setTotalObjectives,
        setObjectivesData: state.setObjectivesData,
        setEditedObjectivesData: state.setEditedObjectivesData,
        setObjectiveCategories: state.setObjectiveCategories
    }), shallow_1.shallow);
    const checkObjectives = react_1.default.useCallback(() => {
        if (isCreate) {
            return editedObjectivesData?.length > 0;
        }
        return totalObjectives > 0;
    }, [editedObjectivesData?.length, isCreate, totalObjectives]);
    const showEmptyState = react_1.default.useCallback(() => {
        if (isComplexity) {
            return false;
        }
        return editedObjectivesData?.length == 0;
    }, [editedObjectivesData?.length, isComplexity, isCreate, totalObjectives]);
    const objectiveId = isIndividual ? editedObjectivesData?.[0]?.id : null;
    const queryParams = {
        limit: 15,
        sortColumn: 'due_date',
        assigneeId: user.id,
        sortDirection: 'asc',
        parentNotAssignedTo: user.id,
        type: ['goal'],
        state: ['running', 'completed', 'reviewed', 'draft', 'edited'],
        periodBegin: (0, dayjs_1.default)(`${new Date().getFullYear()}-01-01`).toISOString(),
        periodEndBefore: (0, dayjs_1.default)(`${new Date().getFullYear()}-12-31`)
            .endOf('day')
            .toISOString()
    };
    const { data: objectivesData, isLoading: isLoadingObjectives, isFetchingNextPage: isFetchingObjectivesNextPage, hasNextPage, fetchNextPage } = (0, useObjectives_1.useGetObjectives)(objectiveId ? `adjustWeightModal-${objectiveId}` : 'adjustWeightModal', customParams || queryParams, {
        enabled: !isIndividual,
        staleTime: 5 * 60 * 1000
    });
    const { data: totalObjectivesData, isLoading: isLoadingTotalObjectives } = (0, useObjectives_1.useGetTotalObjectives)(customParams || queryParams, {
        enabled: isIndividual ? !isComplexity : true,
        staleTime: 5 * 60 * 1000
    });
    const { data: objectiveCategoryData } = (0, useCategories_1.useGetObjectiveCategories)({}, {
        enabled: !isPercentage && (isIndividual ? !isComplexity : true),
        staleTime: 5 * 60 * 1000
    });
    const onScroll = (e) => {
        if (!isFetchingObjectivesNextPage && hasNextPage && !isIndividual) {
            (0, HelperUtils_1.loadMoreValidator)(e.target, 50, () => {
                fetchNextPage();
            });
        }
    };
    (0, react_1.useEffect)(() => {
        if (objectivesData && !isIndividual) {
            const hash = {};
            editedObjectivesData?.forEach((objective) => {
                hash[objective.id] = objective;
            });
            const newObjectives = (0, flatten_1.default)(objectivesData?.pages?.map((page) => {
                return page?.data?.map((d) => {
                    return hash[d.id] ? hash[d.id] : d;
                });
            }));
            const restructuredObjectives = (0, helper_1.restructureObjectivesData)(newObjectives, fromBadgeWeight);
            setObjectivesData(restructuredObjectives);
            setEditedObjectivesData(restructuredObjectives);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isIndividual,
        fromBadgeWeight,
        objectivesData,
        setEditedObjectivesData,
        setObjectivesData
    ]);
    (0, react_1.useEffect)(() => {
        if (totalObjectivesData?.data) {
            const { totalWeights, totalObjectives } = totalObjectivesData?.data || {};
            setTotalWeights(totalWeights);
            setTotalObjectives(totalObjectives);
        }
    }, [setTotalObjectives, setTotalWeights, totalObjectivesData]);
    (0, react_1.useEffect)(() => {
        if (objectiveCategoryData?.data) {
            setObjectiveCategories(objectiveCategoryData?.data);
        }
    }, [objectiveCategoryData, setObjectiveCategories]);
    return (react_1.default.createElement("div", { className: "px-[24px] w-full overflow-auto", onScroll: onScroll }, isLoadingObjectives || isLoadingTotalObjectives ? (react_1.default.createElement(LoadingComponent_1.default, { className: "mt-[24px]" })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "sticky top-[0px] pt-[4px] bg-n-000 z-[1]" },
            checkObjectives() && !isComplexity && objectiveWeightManage && (react_1.default.createElement(Banner_1.default, null)),
            react_1.default.createElement(Header_1.default, null)),
        showEmptyState() ? (react_1.default.createElement("div", { className: "text-center" }, (0, HelperUtils_1.getObjectiveLocale)('No Objectives'))) : (react_1.default.createElement(react_1.default.Fragment, null,
            editedObjectivesData?.length > 0 &&
                editedObjectivesData?.map((objective, index) => {
                    const isLastIndex = editedObjectivesData?.length - 1 === index;
                    return (react_1.default.createElement(AdjustWeightDetail_1.default, { key: objective?.id, index: index, objective: objective, isLastIndex: isLastIndex }));
                }),
            isFetchingObjectivesNextPage && react_1.default.createElement(LoadingComponent_1.default, null)))))));
};
exports.default = AdjustObjectiveList;
